module.exports = __webpack_public_path__ + "static/logo_white-50c20b030efa56cdb2056d198d027edd.png";